import type { SVGProps } from 'react';

export const RetryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0.75V3C12.315 3 15 5.685 15 9C15 10.1775 14.655 11.2725 14.07 12.195L12.975 11.1C13.3125 10.4775 13.5 9.7575 13.5 9C13.5 6.5175 11.4825 4.5 9 4.5V6.75L6 3.75L9 0.75ZM4.5 8.99871C4.5 11.4812 6.5175 13.4987 9 13.4987V11.2487L12 14.2487L9 17.2487V14.9987C5.685 14.9987 3 12.3137 3 8.99871C3 7.82121 3.345 6.72621 3.93 5.80371L5.025 6.89871C4.6875 7.52121 4.5 8.24121 4.5 8.99871Z"
      fill={props.fill ?? '#696F88'}
    />
  </svg>
);

export default RetryIcon;
